import type { AreaCatalog } from '../area';
import type { account as en } from '../en/account';

export const account = {
  // --- Page frame and the four group headings ---
  'account.page.title': 'Konto',
  'account.profile.title': 'Profil',
  'account.signIn.title': 'Anmeldung',
  'account.reach.title': 'Erreichbarkeit',
  'account.agents.title': 'Agenten',
  'account.storage.title': 'Speicher',
  'account.storage.files': 'Dateien',
  'account.storage.used': '{alive} von {limit}',
  'account.storage.today': 'Heute {today} von {dayLimit}',
  'account.group.help': 'Über {group}',
  'account.signIn.help':
    'Ein Anmeldedienst, den du hier verbindest, kann dich anmelden. Ein Konto bei einem Anmeldedienst, das nur dieselbe Adresse hat, gelangt nie in dieses Konto.',
  'account.reach.help':
    'Wer keine Aufgaben mit dir teilt, erreicht dich als Kontakt; andere müssen dir die Verantwortung oder die Zuständigkeit erst anbieten, und du nimmst sie an, außer du erlaubst ihnen hier, dich direkt einzusetzen.',
  'account.agents.help':
    'Ein Agent handelt mit deinen Rechten, eingeschränkt auf die Stufe und den Bereich, die du für ihn gewählt hast.',

  // --- Profile: the name ---
  'account.profile.name': 'Name',
  'account.profile.nameField': 'Anzeigename',
  'account.profile.edit': 'Name ändern',
  'account.profile.save': 'Speichern',
  'account.profile.cancel': 'Abbrechen',
  'account.profile.saveFailed': 'Konnte nicht gespeichert werden.',

  // --- Profile: the handle ---
  'account.handle.label': 'Kennung',
  'account.handle.none': 'noch keine',
  'account.handle.change': 'Kennung ändern',
  'account.handle.pick': 'Kennung wählen',
  'account.handle.until': 'bis {date}',
  'account.handle.opensAt': 'Du kannst sie am {date} wieder ändern.',
  'account.handle.field': 'Kennung',
  'account.handle.hint':
    '5 bis 24 Buchstaben, Ziffern oder Unterstriche. Du kannst sie einmal alle {days} Tage ändern.',
  'account.handle.save': 'Speichern',
  'account.handle.cancel': 'Abbrechen',
  'account.handle.remove': 'Kennung entfernen',
  'account.handle.removeQuestion':
    'Entfernen? Niemand sonst kann sie bekommen, und du kannst nach {days} Tagen wieder eine wählen.',
  'account.handle.removeConfirm': 'Entfernen',
  'account.handle.keep': 'Behalten',
  'account.handle.shape.length': 'Eine Kennung hat {min} bis {max} Zeichen.',
  'account.handle.shape.letter': 'Eine Kennung beginnt mit einem Buchstaben.',
  'account.handle.shape.chars':
    'Eine Kennung besteht nur aus Buchstaben a-z, Ziffern und Unterstrichen.',
  'account.handle.error.noneToClear': 'Du hast keine Kennung, die du entfernen könntest.',
  'account.handle.error.same': 'Das ist schon deine Kennung.',
  'account.handle.error.cooldown': 'Deine Kennung kann sich am {date} wieder ändern.',
  'account.handle.error.notAvailable': 'Diese Kennung ist nicht verfügbar.',
  'account.handle.error.personOnly': 'Nur eine Person hat eine Kennung.',
  'account.handle.error.rateLimited':
    'Zu viele Versuche, die Kennung zu ändern. Bitte warte eine Weile.',

  // --- Profile: the address ---
  'account.email.label': 'Adresse',
  'account.email.verified': 'bestätigt',
  'account.email.change': 'Ändern',
  'account.email.verify': 'Bestätigen',
  'account.email.verifyFailed': 'Es konnte kein Code gesendet werden.',
  'account.email.dialogTitle': 'Adresse ändern',
  'account.email.newLabel': 'Neue Adresse',
  'account.email.newHint':
    'Du genehmigst den Wechsel über deine jetzige Adresse und bestätigst danach die neue.',
  'account.email.codeFrom': 'Code aus der Mail an {email}',
  'account.email.continue': 'Weiter',
  'account.email.approve': 'Genehmigen',
  'account.email.confirm': 'Adresse ändern',
  'account.email.approvalSent': 'Sieh im Postfach {email} nach, um den Wechsel zu genehmigen.',
  'account.email.verifySent': 'Sieh im Postfach {email} nach, um die Adresse zu bestätigen.',
  'account.email.codeFailed': 'Dieser Code hat nicht funktioniert.',
  'account.email.changed': 'Adresse geändert.',

  // --- Profile: the language ---
  'account.locale.title': 'Sprache',
  'account.locale.edit': 'Sprache ändern',
  'account.locale.cancel': 'Abbrechen',
  'account.locale.browser': 'Wie im Browser',
  'account.locale.saveFailed': 'Konnte nicht gespeichert werden.',

  // --- Sign-in: the password ---
  'account.password.label': 'Passwort',
  'account.password.none': 'nicht festgelegt',
  'account.password.setOn': 'festgelegt am {date}',
  'account.password.changeAct': 'Ändern',
  'account.password.setAct': 'Festlegen',
  'account.password.changeTitle': 'Passwort ändern',
  'account.password.setTitle': 'Passwort festlegen',
  'account.password.setHint':
    'Ein Passwort ist dein eigener Zugang, zusätzlich zu jedem Anmeldedienst, den du verbindest.',
  'account.password.current': 'Aktuelles Passwort',
  'account.password.new': 'Neues Passwort',
  'account.password.minLength': 'Mindestens 8 Zeichen.',
  'account.password.confirm': 'Neues Passwort bestätigen',
  'account.password.mismatch': 'Stimmt nicht überein.',
  'account.password.setButton': 'Passwort festlegen',
  'account.password.set':
    'Passwort festgelegt. Du kannst dich jetzt auch mit deiner E-Mail-Adresse und deinem Passwort anmelden.',
  'account.password.changeButton': 'Passwort ändern',
  'account.password.changed': 'Passwort geändert. Deine anderen Sitzungen wurden abgemeldet.',
  'account.password.changeFailed': 'Konnte nicht geändert werden.',
  'account.password.setFailed': 'Das Passwort konnte nicht gesetzt werden.',

  // --- Sign-in providers ---
  'account.providers.add': 'Anmeldedienst verbinden',
  'account.providers.disconnect': 'Trennen',
  'account.providers.onlyWayIn': 'dein einziger Zugang',
  'account.providers.connectFailed': 'Konnte nicht verbunden werden.',
  'account.providers.disconnectFailed': 'Konnte nicht getrennt werden.',
  'account.providers.alreadyLinked':
    'Diese Identität ist hier schon mit einem anderen Konto verbunden.',
  'account.providers.roundTripFailed':
    'Dieser Anmeldedienst konnte nicht verbunden werden. Versuch es noch einmal.',
  'account.providers.connectedTitle': '{provider} verbunden',
  'account.providers.providerFallback': 'Anmeldedienst',
  'account.providers.accepts':
    'Über {provider} kann man sich jetzt als {identity} bei diesem Konto anmelden',
  'account.providers.notYou': 'Wenn das nicht du bist, trenne die Verbindung jetzt.',
  'account.providers.keep': 'Diese Anmeldung behalten',
  'account.providers.identityFallback': 'verbunden',
  'account.providers.identityJustChosen': 'das gerade gewählte Konto',

  // --- Reach: contacts ---
  'account.contacts.title': 'Kontakte',
  'account.contacts.none': 'noch keine',
  'account.contacts.more': '+{count}',
  'account.contacts.waiting': '{count} warten',
  'account.contacts.open': 'Kontakte öffnen',

  // --- Reach: who may seat me directly ---
  'account.seat.label': 'Darf mich einsetzen',
  'account.seat.only': 'Nur {names}',
  'account.seat.nobody': 'Niemand direkt',
  'account.seat.edit': 'Ändern, wer mich einsetzen darf',
  'account.seat.dialogTitle': 'Wer mich direkt einsetzen darf',
  'account.seat.dialogHint':
    'Andere müssen dir die Verantwortung oder die Zuständigkeit erst anbieten, und du nimmst sie an. Wen du hier erlaubst, darf dich direkt einsetzen.',
  'account.seat.done': 'Fertig',

  // --- Reach: notifications on this device ---
  'account.push.label': 'Dieses Gerät',
  'account.push.on': 'Benachrichtigungen an',
  'account.push.off': 'Benachrichtigungen aus',
  'account.push.devicesOn': { one: '{count} Gerät an', other: '{count} Geräte an' },
  'account.push.unsupported': 'In diesem Browser nicht verfügbar.',
  'account.push.needsInstall':
    'Füge Tesserano zuerst zu deinem Home-Bildschirm hinzu und schalte Benachrichtigungen dann in der installierten App ein.',
  'account.push.blocked':
    'Benachrichtigungen für Tesserano sind in den Einstellungen dieses Browsers blockiert.',
  'account.push.turnOn': 'Einschalten',
  'account.push.turnOff': 'Ausschalten',
  'account.push.badSubscription':
    'Dieser Browser hat ein Abonnement geliefert, das der Server nicht verwenden kann.',
  'account.push.turnOnFailed':
    'Benachrichtigungen konnten für dieses Gerät nicht eingeschaltet werden.',
  'account.push.turnOffFailed':
    'Benachrichtigungen konnten für dieses Gerät nicht ausgeschaltet werden.',
  'account.push.testBody': 'Benachrichtigungen sind für dieses Gerät eingeschaltet.',

  // --- Agents ---
  'account.agents.connectorSince': 'verbundene App · seit {date}',
  'account.agents.keySince': 'Schlüssel · seit {date}',
  'account.agents.reach.groups': '{groups}',
  'account.agents.reach.groupsOwn': '{groups} und deine eigenen Aufgaben',
  'account.agents.open': 'Details zu {name}',
  'account.agents.detail.lane': 'Art',
  'account.agents.detail.connector': 'Verbundene App',
  'account.agents.detail.key': 'Agentenschlüssel',
  'account.agents.detail.label': 'Bezeichnung',
  'account.agents.detail.actsAs': 'Handelt als',
  'account.agents.detail.may': 'Darf',
  'account.agents.detail.where': 'Wo',
  'account.agents.detail.since': 'Seit',
  'account.agents.revoke': 'Widerrufen',
  'account.agents.add': 'Agent hinzufügen',
  'account.agents.lanes': 'Wie sich der Agent verbindet',
  'account.agents.lane.claude': 'Claude verbinden',
  'account.agents.lane.key': 'Schlüssel erstellen',

  // --- Connect Claude ---
  'account.claude.hint':
    'Claude kann deine Aufgaben finden, lesen und ändern, wenn du darum bittest. Füge Tesserano einmal mit dieser Adresse zu Claude hinzu.',
  'account.claude.addressLabel': 'Adresse zum Einfügen in Claude',
  'account.claude.copy': 'Kopieren',
  'account.claude.copied': 'Kopiert.',
  'account.claude.selected':
    'Die Adresse ist markiert. Kopiere sie mit dem Kopierbefehl deines Geräts.',
  'account.claude.step1': 'Öffne in Claude „Customize“ und dann „Connectors“.',
  'account.claude.step2':
    'Wähle „Add custom connector“. Gib als Namen Tesserano ein, füge die Adresse ein und wähle „Add“.',
  'account.claude.step3':
    'Wähle „Connect“. Melde dich bei Tesserano an, falls gefragt, und wähle dann „Erlauben“.',

  // --- Delete account ---
  'account.deletion.title': 'Konto löschen',
  'account.deletion.hint':
    'Meldet dich sofort überall ab. Deine persönlichen Daten werden nach {days} Tagen entfernt.',
  'account.deletion.open': 'Löschen…',
  'account.deletion.dialogTitle': 'Dein Konto löschen',
  'account.deletion.now':
    'Jetzt: Du wirst auf jedem Gerät abgemeldet, deine Agentenschlüssel funktionieren nicht mehr, deine Geräte erhalten keine Benachrichtigungen mehr, und niemand kann dich zu neuen Aufgaben hinzufügen. Dein Name bleibt an den Aufgaben stehen, an denen du beteiligt warst.',
  'account.deletion.after':
    'Nach {days} Tagen: Dein Name, deine Adresse, deine Anmeldemethoden, Kontakte und Einstellungen werden entfernt. An diesen Aufgaben steht dann „Gelöschtes Konto“ statt deines Namens. Die Aufgaben selbst bleiben.',
  'account.deletion.restore':
    'Bis dahin können die Betreibenden dieser Instanz das Konto wiederherstellen. Du selbst kannst das Löschen nicht rückgängig machen.',
  'account.deletion.typeToConfirm': 'Gib zur Bestätigung deine Adresse ein',
  'account.deletion.cancel': 'Abbrechen',
  'account.deletion.confirm': 'Konto löschen',
} as const satisfies AreaCatalog<typeof en>;
